import {Container} from "../../components/LayoutHelpers";
import {motion} from "framer-motion";
import {Compa} from "../../components/Compa";
import React from "react";
import "./HeroSection.css"

export default function HeroSection(props) {
    return <section className="hero">
        <div className="brand-blob brand-blob--red brand-blob--top-left" aria-hidden/>
        <div className="brand-blob brand-blob--orange brand-blob--top-right" aria-hidden/>
        <Container className="hero-grid">
            <div className="hero-copy">
                <motion.h1 initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} transition={{duration: 0.5}}
                           className="h1">
                    Más valor, todo el control <span className="text-brand">cero fricción</span>
                </motion.h1>
                <p className="lead">
                    Implementamos automatizaciones y asistentes prácticos sobre tu negocio y herramientas actuales.
                    <strong> Pilotamos en 2–4 semanas</strong> con objetivos medibles. Si no aporta, no escalamos.
                </p>
                <div className="hero-actions">
                    <a href="#contacto" className="btn-primary">Reservar diagnóstico</a>
                    <a href="#servicios" className="btn-outline">Ver servicios</a>
                </div>
                <div className="hero-bullets" aria-label="Beneficios">
                    <div className="bullet"><span className="dot dot-red"/> Impacto en semanas</div>
                    <div className="bullet"><span className="dot dot-orange"/> Sin cambiar de herramientas</div>
                </div>
            </div>

            <motion.div initial={{opacity: 0, scale: 0.98}} animate={{opacity: 1, scale: 1}}
                        transition={{duration: 0.6, delay: 0.1}} className="hero-card">
                <div className="hero-card-glow" aria-hidden/>
                <div className="card hero-card-inner">
                    <div className="hero-card-head">
                        <div className="hero-card-id">
                            <Compa size={56}/>
                            <div>
                                <div className="strong">Compa</div>
                                <div className="muted small">tu guía de eficiencia</div>
                            </div>
                        </div>
                        <span className="badge">Agente IA</span>
                    </div>

                    <div className="hero-card-list">
                        <div className="mini-card">
                            <div className="mini-title">Automatización de tu stack</div>
                            <div className="muted small">Email, facturas, agenda...</div>
                        </div>
                        <div className="mini-card">
                            <div className="mini-title">Formado en tu negocio</div>
                            <div className="muted small">Preguntas con fuentes sobre tu documentación.</div>
                        </div>
                        <div className="mini-card">
                            <div className="mini-title">Diseña las mejores estrategias</div>
                            <div className="muted small">Convierte cada lead en cliente final.</div>
                        </div>
                    </div>
                </div>
            </motion.div>
        </Container>
    </section>

}